import { Shield, Search, Globe, Crown, Truck, ScanEye } from "lucide-react";

export const COMPANY = {
  name: "Blackthorne Stratton",
  tagline: "Understand · Advise · Protect",
  email: "info@blackthornestratton.com",
  phone: "+44 7584 112148",
  phoneHref: "tel:+447584112148",
  location: "London & Worldwide",
};

export const VALUE_PROPS = [
  { icon: Shield, title: "Protect", text: "People, assets and reputation." },
  { icon: Search, title: "Investigate", text: "Uncover the truth with precision." },
  { icon: Globe, title: "Advise", text: "Strategic guidance to manage risk." },
  { icon: ScanEye, title: "Prepare", text: "Proactive solutions for tomorrow." },
];

export const SERVICES = [
  {
    id: "close-protection",
    title: "Close Protection",
    icon: Shield,
    summary:
      "Discreet, professional protection for executives, high-net-worth individuals, public figures and private families.",
    description:
      "Our approach focuses on low-profile protective operations, advance planning, situational awareness and client confidence — ensuring safety without disrupting daily life or business activity.",
    items: [
      "Executive protection",
      "Residential security",
      "Secure transportation coordination",
      "Event and venue protection",
      "Travel risk management",
      "Protective surveillance & counter-surveillance",
    ],
    image: "/images/vauxhall-wide.jpg",
  },
  {
    id: "investigations",
    title: "Investigations",
    icon: Search,
    summary:
      "Confidential, evidence-led investigative services for corporate, legal and private clients.",
    description:
      "We support clients in identifying threats, gathering intelligence and managing sensitive matters with professionalism and complete discretion.",
    items: [
      "Corporate investigations",
      "Workplace misconduct investigations",
      "Due diligence enquiries",
      "Surveillance operations",
      "Fraud and theft investigations",
      "Internal investigations",
      "Intelligence gathering & reporting",
    ],
    image: "/images/investigations-desk.jpg",
  },
  {
    id: "behavioural-detection",
    title: "Behavioural Detection",
    icon: ScanEye,
    summary:
      "Behavioural analysis and threat detection integrated into protective and investigative operations.",
    description:
      "By understanding human behaviour, environmental indicators and pre-incident signals, we help clients identify risk before escalation occurs.",
    items: [
      "Threat recognition & assessment",
      "Hostile reconnaissance detection",
      "Situational awareness programmes",
      "Staff behavioural awareness training",
      "Security screening support",
      "Protective intelligence operations",
    ],
    image: "/images/vauxhall-portrait.jpg",
  },
  {
    id: "risk-consultancy",
    title: "Risk & Security Consultancy",
    icon: Globe,
    summary:
      "Strategic advisory designed to strengthen resilience, reduce vulnerability and improve operational security.",
    description:
      "Our consultancy model is built around understanding each client's environment, objectives and exposure to risk — translating insight into measurable protective strategy.",
    items: [
      "Security risk assessments",
      "Protective security reviews",
      "Corporate security strategy",
      "Physical penetration testing",
      "Crisis management planning",
      "Security audits & compliance reviews",
      "Operational security consultancy",
      "Event security planning",
    ],
    image: "/images/hero-skyline.jpg",
  },
  {
    id: "estate-management",
    title: "Estate & Portfolio Management",
    icon: Crown,
    summary:
      "Discreet estate and portfolio management for high-net-worth individuals, family offices and private estates.",
    description:
      "We combine strategic oversight with meticulous day-to-day management — ensuring residential, commercial and investment assets are protected, maintained and operated to the highest standards.",
    items: [
      "Asset protection & risk management",
      "Estate operations management",
      "Household & estate staff management",
      "Contractor & supplier management",
      "Strategic portfolio oversight",
      "Acquisition, disposal & development support",
    ],
    image: "/images/estate-building.jpg",
  },
  {
    id: "asset-transportation",
    title: "Discreet Asset Transportation",
    icon: Truck,
    summary:
      "Secure, confidential transportation for high-value assets, sensitive materials and personal possessions.",
    description:
      "Operating with complete confidentiality, our service ensures the safe movement of valuable items while minimising risk and maintaining client privacy.",
    items: [
      "Luxury goods & fine art",
      "Confidential documents",
      "Jewellery & high-value items",
      "Cash equivalents",
      "Secure chain-of-custody handling",
      "Route planning & risk assessment",
    ],
    image: "/images/asset-transport.jpg",
  },
];

export const PRINCIPLES = [
  { title: "Understanding before action", text: "Every engagement begins with intelligence, context and a complete picture of the threat profile." },
  { title: "Discretion without compromise", text: "Our work is low-profile by design — protecting privacy, reputation and continuity at all times." },
  { title: "Intelligence-led decision making", text: "We act on insight, not assumption — anticipating risk before it materialises." },
  { title: "Professionalism in every environment", text: "Operational experience paired with a measured, advisory mindset across all settings." },
  { title: "Client-focused protective solutions", text: "Bespoke strategy built around each client's objectives, environment and exposure." },
];
